import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from "react"
import { UserContext } from "../../Contexts/UserContext"
import './RFPBuilderPage.css'
import { Button, FloatingChat, Modal } from "@nxtvid/component-library"
import { SelectedRFPContext } from "../../Contexts/SelectedRFPContext"
import handleNavigation from "../../Components/handleNavigate"
import {  useNavigate } from "react-router-dom"
import exportRFPasDocx from "./utilities/exportRFPasDocx"
import { ChatInput } from "./components/ChatInput"
import { ChatSession } from "./components/ChatSession"
import { fetchRFPData } from "./services/fetchRFPData"
import { newRFPMessage } from "./predefined_agent_messages/newRFPMessage"
import { welcomeBackMessage } from "./predefined_agent_messages/welcomeBackMessage"
import { additionalContextMessage } from "./predefined_agent_messages/additionalContextMessage"
import { saveRFP } from "./services/saveRFP"
import { updateRFPContent } from "./utilities/updateRFPContent"
import { RFPPage } from "./components/RFPPage"
import { RFPSection } from "./components/RFPSection"
import { zoomIn, zoomOut } from "./utilities/RFPZoomFunctions"
import { deactivateRainbowRing } from "./utilities/rainbowRingFunctions"
import { changeSingleValue } from "./agent_run_functions/changeSingleValue"
import { getSingleValue } from "./agent_run_functions/getSingleValue"
import { getEntireRFPState } from "./agent_run_functions/getEntireRFPState"
import { changeMultipleValues } from "./agent_run_functions/changeMultipleValues"
import { AuthContext } from "../../Contexts/AuthContext"

export const RFPBuilderPage = ()=>{
    const {userInfo} = useContext(UserContext)
    const {isAuthenticated, setIsAuthenticated} = useContext(AuthContext)
    const zoomInIcon = require('../../Images/zoom-in-icon.png')
    const zoomOutIcon = require('../../Images/zoom-out-icon.png')
    const saveIcon = require('../../Images/save-rfp-icon.png')
    const backIcon = require('../../Images/back-icon.png')
    const rfpIcon = require('../../Images/rfp-icon.png')
    const chatIcon = require('../../Images/chat-icon.png')
    const exportIcon = require('../../Images/export-rfp-icon.png')
    const [documentData, setDocumentData] = useState({
        "Project-Name": "Project Title",
        "Issued-By": "",
        "Proposal-Submission-Deadline": "",
        "Company-Name" : "",
        "Mission-Statement": "",
        "Brand-Guidelines":[""],
        "Project-Objective": '',
        "Target-Audience": [''],
        "Key-Themes-and-Messaging": [''],
        "Featured-Products-and-Services": [''],
        "Number-of-Videos": '',
        "Video-Length": '',
        "Video-Style": [''],
        "Project-Kickoff-Date": "",
        "Pre-Production-Timeline":[''],
        "Shoot-Dates": [''],
        "Deliverables-Due-Dates": "",
        "Proposal-Evaluation-Criteria":[''],
        "Estimated-Budget": "",
        "Legal-Requirements": [''],
        "Additional-Notes": ""
    })
    const [chatSession, setChatSession] = useState([]);
    let enterPressed = false;
    const scrollTopRef = useRef(0);
    const scrollLeftRef = useRef(0);
    const {selectedRFP, setSelectedRFP} = useContext(SelectedRFPContext)
    const [canEdit, setCanEdit] = useState(false)
    const navigate = useNavigate()
    const chatSessionRef = useRef(chatSession);
    const [sectionInFocus, setSectionInFocus] = useState('Chat')
    // Modal States
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [modalType, setModalType] = useState('confirm')
    const [modalSize, setModalSize] = useState('medium')
    const [modalTitle, setModalTitle] = useState('')
    const [modalDescription, setModalDescription] = useState('' )
    const [modalOnConfirm, setModalOnConfirm] = useState(() => () => {})
    const [modalOnCancel, setModalOnCancel] = useState(() => () => {})
    const [modalConfirmButtonText, setModalConfirmButtonText] = useState('')
    const [modalCancelButtonText, setModalCancelButtonText] = useState('')


    // Redirect to home if user is not logged in
    useEffect(() => { 
        if (isAuthenticated === null) return; 
    
        if (userInfo.isVideographer === null) {
          window.location.href = '/';
        }
      }, [userInfo]);


    // Update chat session ref when chat session changes
     useEffect(() => {
        chatSessionRef.current = chatSession;
      }, [chatSession]);



    // get RFP data and if not, set RFP data to default (also affects initial chat message)
    useEffect(() => {
        if (!userInfo._id) return;

        if (selectedRFP) {
            const fetchData = async () => {
                const data = await fetchRFPData(userInfo, selectedRFP);
                setDocumentData(data.rfp.documentData);
                setCanEdit(data.canEdit);
                if (chatSession.length === 0) {
                  setChatSession([...chatSession, additionalContextMessage(userInfo), welcomeBackMessage(userInfo)]);
                }
            };
            fetchData();
            if(chatSession.length === 0){
                setChatSession([...chatSession, additionalContextMessage(userInfo), welcomeBackMessage(userInfo)])
            }    
        }
        else{
            setCanEdit(true)
            if(chatSession.length === 0){
                setChatSession([...chatSession, additionalContextMessage(userInfo), newRFPMessage(userInfo)])
            }
            setDocumentData(
                {
                    "Project-Name": "Project Title",
                    "Issued-By": userInfo.company,
                    "Proposal-Submission-Deadline": "",
                    "Company-Name" : userInfo.company,
                    "Mission-Statement": "",
                    "Brand-Guidelines":[""],
                    "Project-Objective": '',
                    "Target-Audience": [''],
                    "Key-Themes-and-Messaging": [''],
                    "Featured-Products-and-Services": [''],
                    "Number-of-Videos": '',
                    "Video-Length": '',
                    "Video-Style": [''],
                    "Project-Kickoff-Date": "",
                    "Pre-Production-Timeline":[''],
                    "Shoot-Dates": [''],
                    "Deliverables-Due-Dates": "",
                    "Proposal-Evaluation-Criteria":[''],
                    "Estimated-Budget": "",
                    "Legal-Requirements": [''],
                    "Additional-Notes": ""
                }
            )
        }
    }, [selectedRFP, userInfo]); 
        

    // scroll position effect for RFP Document
    useEffect(() => {
        const container = document.querySelector('.rfp-container');
        if (!container) return;
    
        const updateScrollPosition = () => {
            scrollTopRef.current = container.scrollTop;
            scrollLeftRef.current = container.scrollLeft;
        };
    
        container.addEventListener("scroll", updateScrollPosition);
    
        return () => {
            container.removeEventListener("scroll", updateScrollPosition);
        };
    }, []);

    // run agentic functions when chatSession updates
    useEffect(()=>{
        const lastMessage = chatSession[chatSession.length - 1];
        if (!lastMessage || !lastMessage.parts) return;
        const functionCallPart = lastMessage.parts.find(part => part.functionCall);
        if (functionCallPart?.functionCall?.name === 'get_entire_RFP_state') {
            getEntireRFPState(chatSession, documentData, chatSessionRef, setChatSession, userInfo);
        }
        else if (functionCallPart?.functionCall?.name === 'get_single_value') {
            getSingleValue(functionCallPart.functionCall.args.field, chatSession, documentData, chatSessionRef, setChatSession, userInfo);
        }
        else if(functionCallPart?.functionCall?.name === 'change_single_value'){
            changeSingleValue(functionCallPart.functionCall.args.field, functionCallPart.functionCall.args.new_value , chatSession, documentData, setDocumentData, chatSessionRef, setChatSession, userInfo);
        }
        else if(functionCallPart?.functionCall?.name === 'change_multiple_values'){
            changeMultipleValues(functionCallPart.functionCall.args.changes, chatSession, documentData, setDocumentData, chatSessionRef, setChatSession, userInfo);
        }
        
    }, [chatSession])

    //render RFP page sections
    const renderPageSections = () =>{
        return ([
            <div className="rfp-page-section">
                <h2 className="rfp-title" contentEditable='true' suppressContentEditableWarning={true} onBlur={(e)=>updateRFPContent('Project-Name', e.target.textContent, undefined, setDocumentData, enterPressed)}>{documentData['Project-Name']}</h2>
                <div className='inline-rfp-section'><p className="rfp-section-title">Issued By:</p><p className="rfp-section-content" contentEditable='true' suppressContentEditableWarning= {true} onBlur = {(e)=>updateRFPContent('Issued-By', e.target.textContent, undefined, setDocumentData, enterPressed)}>{documentData['Issued-By']}</p></div>
                <div className='inline-rfp-section'><p className="rfp-section-title">Proposal Submission Deadline:</p><p className="rfp-section-content" contentEditable='true' suppressContentEditableWarning= {true} onBlur = {(e)=>updateRFPContent('Proposal-Submission-Deadline', e.target.textContent, undefined, setDocumentData, enterPressed)}>{documentData['Proposal-Submission-Deadline']}</p></div>
                <div className='inline-rfp-section'><p className="rfp-section-title">Estimated Budget:</p><p className="rfp-section-content" contentEditable='true' suppressContentEditableWarning= {true} onBlur = {(e)=>updateRFPContent('Estimated-Budget', e.target.textContent, undefined, setDocumentData, enterPressed)}>{documentData['Estimated-Budget']}</p></div>
                <div className = 'rfp-separator'></div>
            </div>,
            <div className="rfp-page-section">
                <h3 className = 'rfp-subtitle'>Company Overview</h3>
                <RFPSection documentData={documentData} setDocumentData={setDocumentData} enterPressed={enterPressed} section = 'Company-Name' content = {documentData['Company-Name']} updateRFPContent = {updateRFPContent} title = 'Company Name:'/>
                <div className="rfp-spacer"/>
            </div>,
            <div className="rfp-page-section">
                <RFPSection documentData={documentData} setDocumentData={setDocumentData} enterPressed={enterPressed} section = 'Mission-Statement' content = {documentData['Mission-Statement']} updateRFPContent = {updateRFPContent} title = 'Mission Statement:'/>
                <div className="rfp-spacer"/>
            </div>,
            <div className="rfp-page-section">
                <RFPSection documentData={documentData} setDocumentData={setDocumentData} enterPressed={enterPressed} section = 'Brand-Guidelines' content = {documentData['Brand-Guidelines']} updateRFPContent = {updateRFPContent} title = 'Brand Guidelines:'/>
                <div className = 'rfp-separator'></div>
            </div>,     
            <div className="rfp-page-section">
                <h3 className = 'rfp-subtitle'>Project Overview</h3>
                <RFPSection documentData={documentData} setDocumentData={setDocumentData} enterPressed={enterPressed} section = 'Project-Objective' content = {documentData['Project-Objective']} updateRFPContent = {updateRFPContent} title = 'Objective:'/>
                <div className="rfp-spacer"/>
            </div>,
            <div className="rfp-page-section">
                <RFPSection documentData={documentData} setDocumentData={setDocumentData} enterPressed={enterPressed} section = 'Target-Audience' content = {documentData['Target-Audience']} updateRFPContent = {updateRFPContent} title = 'Target Audience:'/>
                <div className="rfp-spacer"/>
            </div>,
            <div className="rfp-page-section">
                <RFPSection documentData={documentData} setDocumentData={setDocumentData} enterPressed={enterPressed} section = 'Key-Themes-and-Messaging' content = {documentData['Key-Themes-and-Messaging']} updateRFPContent = {updateRFPContent} title = 'Key Themes & Messaging:'/>
                <div className="rfp-spacer"/>
            </div>, 
            <div className="rfp-page-section">
                <RFPSection documentData={documentData} setDocumentData={setDocumentData} enterPressed={enterPressed} section = 'Featured-Products-and-Services' content = {documentData['Featured-Products-and-Services']} updateRFPContent = {updateRFPContent} title = 'Featured Products & Services:'/>
                <div className = 'rfp-separator'/>
            </div>,
            <div className="rfp-page-section">
                <h3 className = 'rfp-subtitle'>Video Details</h3>
                <RFPSection documentData={documentData} setDocumentData={setDocumentData} enterPressed={enterPressed} section = 'Number-of-Videos' content = {documentData['Number-of-Videos']} updateRFPContent = {updateRFPContent} title = 'Number of Videos:'/>
                <div className="rfp-spacer"/>
            </div>,
            <div className="rfp-page-section">
                <RFPSection documentData={documentData} setDocumentData={setDocumentData} enterPressed={enterPressed} section = 'Video-Length' content = {documentData['Video-Length']} updateRFPContent = {updateRFPContent} title = 'Video Length:'/>
                <div className="rfp-spacer"/>
            </div>,
            <div className="rfp-page-section">
                <RFPSection documentData={documentData} setDocumentData={setDocumentData} enterPressed={enterPressed} section = 'Video-Style' content = {documentData['Video-Style']} updateRFPContent = {updateRFPContent} title = 'Video Style:'/>
                <div className = 'rfp-separator'></div>
            </div>,
            <div className="rfp-page-section">
                <h3 className = 'rfp-subtitle'>Project Timeline</h3>
                <RFPSection documentData={documentData} setDocumentData={setDocumentData} enterPressed={enterPressed} section = 'Proposal-Submission-Deadline' content = {documentData['Proposal-Submission-Deadline']} updateRFPContent = {updateRFPContent} title = 'Proposal Submission Deadline:'/>
                <div className="rfp-spacer"/>
            </div>,
            <div className="rfp-page-section">
                <RFPSection documentData={documentData} setDocumentData={setDocumentData} enterPressed={enterPressed} section = 'Project-Kickoff-Date' content = {documentData['Project-Kickoff-Date']} updateRFPContent = {updateRFPContent} title = 'Project Kickoff Date:'/>
                <div className="rfp-spacer"/>
            </div>,
            <div className="rfp-page-section">
                <RFPSection documentData={documentData} setDocumentData={setDocumentData} enterPressed={enterPressed} section = 'Pre-Production-Timeline' content = {documentData['Pre-Production-Timeline']} updateRFPContent = {updateRFPContent} title = 'Pre-Production:'/>
                <div className="rfp-spacer"/>
            </div>,
            <div className="rfp-page-section">
                <RFPSection documentData={documentData} setDocumentData={setDocumentData} enterPressed={enterPressed} section = 'Shoot-Dates' content = {documentData['Shoot-Dates']} updateRFPContent = {updateRFPContent} title = 'Shoot Dates:'/>
                <div className="rfp-spacer"/>
            </div>,
            <div className="rfp-page-section">
                <RFPSection documentData={documentData} setDocumentData={setDocumentData} enterPressed={enterPressed} section = 'Deliverables-Due-Dates' content = {documentData['Deliverables-Due-Dates']} updateRFPContent = {updateRFPContent} title = 'Final Deliverables Due Date:'/>
                <div className = 'rfp-separator'></div>
            </div>,
            <div className="rfp-page-section">
                <h3 className = 'rfp-subtitle'>Evaluation Criteria</h3>
                <RFPSection documentData={documentData} setDocumentData={setDocumentData} enterPressed={enterPressed} section = 'Proposal-Evaluation-Criteria' content = {documentData['Proposal-Evaluation-Criteria']} updateRFPContent = {updateRFPContent} title = 'Proposal Evaluation Criteria:'/>
                <div className="rfp-separator"/>
            </div>,
            <div className="rfp-page-section">
                <h3 className = 'rfp-subtitle'>Budget & Legal Considerations</h3>
                <RFPSection documentData={documentData} setDocumentData={setDocumentData} enterPressed={enterPressed} section = 'Estimated-Budget' content = {documentData['Estimated-Budget']} updateRFPContent = {updateRFPContent} title = 'Estimated Budget:'/>
                <div className="rfp-spacer"/>
            </div>,
            <div className="rfp-page-section">
                <RFPSection documentData={documentData} setDocumentData={setDocumentData} enterPressed={enterPressed} section = 'Legal-Requirements' content = {documentData['Legal-Requirements']} updateRFPContent = {updateRFPContent} title = 'Legal Requirements:'/>
                <div className="rfp-separator"/>
            </div>,
            <div className="rfp-page-section">
                <h3 className = 'rfp-subtitle'>Additional Notes</h3>
                <RFPSection documentData={documentData} setDocumentData={setDocumentData} enterPressed={enterPressed} section = 'Additional-Notes' content = {documentData['Additional-Notes']} updateRFPContent = {updateRFPContent} title = ''/>
            </div>
        ])
    }

    const [pages, setPages] = useState([renderPageSections()])
    const [baseHeight, setBaseHeight] = useState(896)

    // page population functions
    const distributeSectionsToPages = (sections, baseHeight) => {
        let tempPages = [];
        let currentPage = [];
        let currentHeight = 0;
        sections.forEach((section, index) => {
        const sectionHeight = section.offsetHeight;
        if (currentHeight + sectionHeight > baseHeight) {
          
            tempPages.push([currentPage]);
            currentPage = [];
            currentHeight = 0;
        }
        currentPage.push(renderPageSections()[index]);
        currentHeight += sectionHeight;   
        });
        if (currentPage.length > 0) {
            
            tempPages.push([currentPage]);
        }
        return tempPages;
    }
    
    useEffect(() => {
        requestAnimationFrame(() => {
            const sections = Array.from(document.querySelectorAll('.rfp-page-section'));    
            setPages(distributeSectionsToPages(sections, baseHeight));
        });
    }, [documentData, sectionInFocus]); // Runs after content updates 

// Variable for Zoom in and out functions  
const zoomLevels = [0.5, 0.75, 1, 1.25, 1.5, 2]; // Predefined zoom levels
const BASE_WIDTH = 816; // Default width in pixels
const BASE_HEIGHT = Math.round(BASE_WIDTH * (11 / 8.5)); // Maintain aspect ratio

const zoomIndexRef = useRef(zoomLevels.indexOf(1)); // Store zoom index persistently

const [docWidth, setDocWidth] = useState(BASE_WIDTH);
const [docHeight, setDocHeight] = useState(BASE_HEIGHT);
const [fontSize, setFontSize] = useState(16);

const scrollPositionRef = useRef({ left: 0, top: 0 }); // Store scroll position


// allow zoom through ctrl+scroll wheel
useEffect(() => {
    const container = document.querySelector('.rfp-container');

    if (!container) return;

    const handleWheelZoom = (e) => {
        if (e.ctrlKey) { 
            e.preventDefault(); 
            const direction = e.deltaY < 0 ? 1 : -1; 
            if(direction === 1){
                zoomIn(zoomLevels, zoomIndexRef, scrollPositionRef, BASE_WIDTH, BASE_HEIGHT, setDocWidth, setDocHeight, setBaseHeight, setFontSize)
            }
            else if(direction === -1){
                zoomOut(zoomLevels, zoomIndexRef, scrollPositionRef, BASE_WIDTH, BASE_HEIGHT, setDocWidth, setDocHeight, setBaseHeight, setFontSize)
            }
        }
    };
    container.addEventListener('wheel', handleWheelZoom, { passive: false });

    return () => {
        container.removeEventListener('wheel', handleWheelZoom);
    };
}, []);


// send message on enter
useEffect(() => {
    const input = document.querySelector('.chat-input');
    const handler = (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        document.querySelector('.send-message-to-RFP-agent-button')?.click();
      }
    };
    input?.addEventListener('keydown', handler);
    return () => input?.removeEventListener('keydown', handler);
  }, []);

    return(
        <div className="App">
            <div className="rfp-builder-body">
                <div className="background-shades" onClick={(e)=>{e.target.style.display='none'; document.getElementsByClassName("sign-in-card")[0].style.display='none'; document.getElementsByClassName("sign-up-card")[0].style.display='none'; document.getElementsByClassName("forgot-password-card")[0].style.display='none';document.getElementsByClassName("purchase-tokens-card")[0].style.display='none'; document.getElementsByClassName('sign-in-notification-message')[0].textContent=''; document.getElementsByClassName('sign-up-notification-message')[0].textContent=''; }}/>
                {isModalOpen ? <Modal type={modalType} title={modalTitle} description={modalDescription} onConfirm={modalOnConfirm} onClose={modalOnCancel} confirm_button_text={modalConfirmButtonText} cancel_button_text={modalCancelButtonText}/> : <p></p>}
                <div className="rfp-builder-container">
                    <div className={`chat-container ${sectionInFocus === 'Chat' ? 'inFocus' : ''}`}>
                        <ChatSession chatSession = {chatSession} />
                        <div className={`rfp-controls-chat ${sectionInFocus}`}>
                            <Button toolTipMessage ='Back to Dashboard' label = '' className = 'back-button' size = 'small' type = 'primary' icon = {backIcon} onClick={() => {setIsModalOpen(true); setModalType('confirm'); setModalTitle('Back to Home'); setModalDescription("Are you sure you want to leave this page? Your work won't automatically be saved."); setModalCancelButtonText('Cancel'); setModalConfirmButtonText('Go to Home') ;setModalOnCancel(()=>()=>{setIsModalOpen(false)}); setModalOnConfirm(()=>()=>handleNavigation({path:"/", navigate}))}}/>
                            <Button toolTipMessage='Export RFP' label ='' className = 'export-rfp-button' size ='small' type ='primary' icon = {exportIcon} onClick = {()=>exportRFPasDocx(documentData)}/>
                            { canEdit ? <Button toolTipMessage='Save RFP' label='' className='save-button' size = 'small' type = 'primary' icon = {saveIcon} onClick={()=>saveRFP(userInfo, documentData, selectedRFP, setSelectedRFP, setIsModalOpen, setModalType, setModalSize, setModalTitle, setModalDescription, setModalConfirmButtonText, setModalOnConfirm, setModalOnCancel)}/> : null}
                            <Button toolTipMessage='Switch Views' label = '' className={`switch-views-button ${sectionInFocus === 'RFP' ? 'RFP' : 'chat'}`}  size='small' onClick={()=>{sectionInFocus === 'RFP' ? setSectionInFocus('Chat') : setSectionInFocus('RFP'); deactivateRainbowRing()}} icon = {sectionInFocus === 'RFP' ? chatIcon : rfpIcon}/>
                        </div>
                        <ChatInput chatSessionRef = {chatSessionRef} setChatSession = {setChatSession}/> 
                    </div>
                    <div className = {`rfp-container ${sectionInFocus === 'RFP' ? 'inFocus':''}`}>
                        {
                            pages.map(( sections, index ) => (
                                <RFPPage key={index} index={index} docWidth = {docWidth} docHeight={docHeight} fontSize = {fontSize}>
                                    {sections.map((section) => 
                                        {return section}
                                    )}
                                </RFPPage>
                            )
                            )
                        }
                        <div className='zoom-controls'>
                            <Button toolTipMessage='Zoom In' label='' className='zoom-in-button' size = 'small' type = 'primary' icon = {zoomInIcon} onClick={()=>zoomIn(zoomLevels, zoomIndexRef, scrollPositionRef, BASE_WIDTH, BASE_HEIGHT, setDocWidth, setDocHeight, setBaseHeight, setFontSize)}/>
                            <Button toolTipMessage='Zoom Out' label ='' className='zoom-out-button' size = 'small' type = 'primary' icon = {zoomOutIcon} onClick={()=>zoomOut(zoomLevels, zoomIndexRef, scrollPositionRef, BASE_WIDTH, BASE_HEIGHT, setDocWidth, setDocHeight, setBaseHeight, setFontSize)}/>
                        </div>
                        
                    </div>
                    <div className={`rfp-controls ${sectionInFocus}`}>
                            <Button toolTipMessage='Back to Dashboard' label = '' className = 'back-button' size = 'small' type = 'primary' icon = {backIcon} onClick={() => {setIsModalOpen(true); setModalType('confirm'); setModalTitle('Back to Home'); setModalDescription("Are you sure you want to leave this page? Your work won't automatically be saved."); setModalCancelButtonText('Cancel'); setModalConfirmButtonText('Go to Home') ;setModalOnCancel(()=>()=>{setIsModalOpen(false)}); setModalOnConfirm(()=>()=>handleNavigation({path:"/", navigate}))}}/>
                            <Button toolTipMessage='Export RFP' label ='' className = 'export-rfp-button' size ='small' type ='primary' icon = {exportIcon} onClick = {()=>exportRFPasDocx(documentData)}/>
                            { canEdit ? <Button toolTipMessage='Save RFP' label='' className='save-button' size = 'small' type = 'primary' icon = {saveIcon} onClick={()=>saveRFP(userInfo, documentData, selectedRFP, setSelectedRFP, setIsModalOpen, setModalType, setModalSize, setModalTitle, setModalDescription, setModalConfirmButtonText, setModalOnConfirm, setModalOnCancel)}/> : null}
                            <Button toolTipMessage='Switch Views' label = '' className={`switch-views-button ${sectionInFocus === 'RFP' ? 'RFP' : 'chat'}`}  size='small' onClick={()=>{sectionInFocus === 'RFP' ? setSectionInFocus('Chat') : setSectionInFocus('RFP'); deactivateRainbowRing()}} icon = {sectionInFocus === 'RFP' ? chatIcon : rfpIcon}/>
                        </div>
                </div>
            </div>
        </div>
    )
}
